var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-overlay',{staticStyle:{"height":"100vh"},attrs:{"value":_vm.overlay}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64"}})],1),_c('MisCuentas'),_c('iframe',{key:_vm.iframeUpdate,style:(_vm.size < 960
        ? 'width: 100%; height: calc(' + this.screenHeight * 0.84 + 'px)'
        : 'width: 100%; height: calc(80vh)'),attrs:{"src":_vm.gameUrl,"frameborder":"0"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }